module.exports = __webpack_public_path__ + "img/signin_icon__change_normal.beaf3f6b.svg";